import { List, Box, Stack } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as ProfileIcon } from "src/assets/svg-icons/side-bar/profile.svg";
import { ReactComponent as ReportsIcon } from "src/assets/svg-icons/side-bar/reports.svg";
import { ReactComponent as TransIcon } from "src/assets/svg-icons/side-bar/transactions.svg";
import LogoIcon from "src/assets/svg-icons/arsann-logo.svg";
import { useRecoilState } from "recoil";
import { authState } from "src/store/auth";
import NavItem from "./nav-item";

export const NavItems: React.FC = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [auth] = useRecoilState(authState);
  const { permissions } = auth;

  function checkIncludingPath(path: string) {
    return pathname.includes(path);
  }

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  const hasAtLeastOneDashPerm: boolean = Object.values(
    permissions?.client_dashboard ?? [],
  ).some((v) => v === true);

  return (
    <Stack
      maxWidth={"220px"}
      minWidth={"220px"}
      pb={"15px"}
      height={"100vh"}
      maxHeight={"100vh"}
      position={"sticky"}
      top={"0"}
      bgcolor="background.paper"
    >
      <Box
        px={"25px"}
        py={"19px"}
        mb={"20px"}
        borderBottom={"1px solid #393945;"}
      >
        <img src={LogoIcon} width={61} alt="" />
      </Box>
      <List
        sx={{
          width: "100%",
          maxWidth: 360,
          bgcolor: "background.paper",
          padding: "0 25px",
        }}
        component="nav"
        aria-labelledby="nested-list-subheader"
      >
        {/* Reports */}
        {hasAtLeastOneDashPerm && (
          <NavItem
            label="Dashboard"
            path="reports/sales"
            icon={ReportsIcon}
            active={checkIncludingPath("reports")}
            onClick={handleNavigation}
          />
        )}

        {/* tickets validation */}
        {permissions?.ticket_validation?.view && (
          <NavItem
            label="Tickets Validation"
            path="tickets-validation"
            icon={TransIcon}
            active={checkIncludingPath("tickets-validation")}
            onClick={handleNavigation}
          />
        )}

        {/* Golf Cart Requests */}
        {permissions?.golf_carts_requests?.view && (
          <NavItem
            label="Golf Carts Requests"
            path="golf-requests"
            icon={ReportsIcon}
            active={checkIncludingPath("golf-requests")}
            onClick={handleNavigation}
          />
        )}

        {/* profile settings */}
        <NavItem
          label="Profile Settings"
          path="profile"
          icon={ProfileIcon}
          active={checkIncludingPath("profile")}
          onClick={handleNavigation}
        />
      </List>
    </Stack>
  );
};
